import { QueryParameters } from '@browsing/utils';
export var getArticleCardUrl = function (_a) {
    var campaignIdentifier = _a.campaignIdentifier, catalog = _a.catalog, sku = _a.sku, source = _a.source, recommendedBy = _a.recommendedBy, themeHash = _a.themeHash;
    var url = "/campaigns/".concat(campaignIdentifier, "/articles/").concat(sku, "?");
    if (recommendedBy) {
        url += "".concat(QueryParameters.Reco, "=").concat(recommendedBy, "&");
    }
    if (catalog) {
        url += "".concat(QueryParameters.CatalogType, "=").concat(catalog, "&");
    }
    if (themeHash) {
        url += "".concat(QueryParameters.ThemeHash, "=").concat(themeHash, "&");
    }
    if (source) {
        url += "".concat(QueryParameters.NavigationSource, "=").concat(source);
    }
    return url;
};
